import { render } from "./JobManagement.vue?vue&type=template&id=6ef14ffb&scoped=true"
import script from "./JobManagement.vue?vue&type=script&lang=js"
export * from "./JobManagement.vue?vue&type=script&lang=js"

import "./JobManagement.vue?vue&type=style&index=0&id=6ef14ffb&scoped=true&lang=css"

import exportComponent from "C:\\mgtspl\\mgtspl\\MGTSPL_FE\\MGTSPL\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ef14ffb"]])

export default __exports__